import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-col flex-grow" }
const _hoisted_2 = { class: "font-medium px-2 py-1 border-b-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "adjudication-list w-full table-auto" }
const _hoisted_6 = { class: "border-b-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", { class: "border-b-2" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Auth ID"),
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Provider"),
  /*#__PURE__*/_createElementVNode("th", null, "Policy"),
  /*#__PURE__*/_createElementVNode("th", null, "Date")
], -1)
const _hoisted_8 = { class: "py-2 text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-center font-mono" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolicyList = _resolveComponent("PolicyList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.historical)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Completed Requests"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Requests to Review"))
    ]),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("thead", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authIdFilter) = $event)),
              class: "text-xs p-2 w-28 h-4 border-2 border-yellow-500 rounded-lg",
              type: "text",
              placeholder: "Filter"
            }, null, 512), [
              [_vModelText, _ctx.authIdFilter]
            ])
          ]),
          _createElementVNode("td", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientFilter) = $event)),
              class: "text-xs p-2 w-28 h-4 border-2 border-yellow-500 rounded-lg",
              type: "text",
              placeholder: "Filter"
            }, null, 512), [
              [_vModelText, _ctx.patientFilter]
            ])
          ]),
          _createElementVNode("td", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.providerFilter) = $event)),
              class: "text-xs p-2 w-28 h-4 border-2 border-yellow-500 rounded-lg",
              type: "text",
              placeholder: "Filter"
            }, null, 512), [
              [_vModelText, _ctx.providerFilter]
            ])
          ]),
          _createElementVNode("td", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.policyFilter) = $event)),
              class: "text-xs p-2 w-28 h-4 border-2 border-yellow-500 rounded-lg",
              type: "text",
              placeholder: "Filter"
            }, null, 512), [
              [_vModelText, _ctx.policyFilter]
            ])
          ]),
          _createElementVNode("td", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateFilter) = $event)),
              class: "text-xs p-2 w-28 h-4 border-2 border-yellow-500 rounded-lg",
              type: "text",
              placeholder: "Filter"
            }, null, 512), [
              [_vModelText, _ctx.dateFilter]
            ])
          ])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAdjudications, (adjudication) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: adjudication.referenceNumber,
            onClick: ($event: any) => (_ctx.selectAdjudication(adjudication.authorizationId)),
            class: _normalizeClass([
                        'adjudication-list-item',
                        'cursor-pointer',
                        _ctx.selectedAuthorizationId === adjudication.authorizationId
                            ? 'bg-blue-300'
                            : 'hover:bg-blue-100'
                    ])
          }, [
            _createElementVNode("td", _hoisted_15, _toDisplayString(adjudication.referenceNumber), 1),
            _createElementVNode("td", _hoisted_16, _toDisplayString(adjudication.patientName), 1),
            _createElementVNode("td", _hoisted_17, _toDisplayString(adjudication.providerName), 1),
            _createElementVNode("td", _hoisted_18, [
              _createVNode(_component_PolicyList, {
                policies: _ctx.filterPolicies(adjudication.policies)
              }, null, 8, ["policies"])
            ]),
            _createElementVNode("td", _hoisted_19, _toDisplayString(adjudication.createdDate), 1)
          ], 10, _hoisted_14))
        }), 128))
      ])
    ])
  ]))
}